<template>
  <div class="site-record">
    <siteSelect class="site-tree-wrap" :showArea="true" :allowSelectArea="false" :siteOnly="true" @selectSite="selectSite"></siteSelect>

    <div class="site-content">
      <water ref="water"></water>
    </div>
  </div>
</template>
<script>
  import siteSelect from '@/components/page/siteSelect'
  import water from '../com/water'

  export default {
    components: {
      siteSelect,
      water,
    },
    methods: {
      selectSite(data) {
        setTimeout(() => {
          this.$refs.water.getType(data)
        }, 100)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .site-record {
    width: 100%;
    height: 95.5vh;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 15px;
    padding: 0 10px;

    .site-tree-wrap {
      height: 100%;
      flex-shrink: 0;
    }

    .site-content {
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 12px;
    }
  }
</style>
